/*! OnlyPlanks box calculator — m² → whole boxes → main add to cart */
(function () {
  if (window.__opBoxBound) return;
  window.__opBoxBound = true;

  var reduce =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function money(n) {
    try {
      return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
      }).format(n);
    } catch (e) {
      return "$" + n.toFixed(2);
    }
  }

  function findQtyInput(root) {
    var scope =
      (root && root.closest("product-info, .product, main, product-details")) ||
      document;
    var selectors = [
      'form[action*="/cart/add"] input[name="quantity"]',
      "quantity-input input[name=\"quantity\"]",
      'input[name="quantity"]',
      ".quantity__input",
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = scope.querySelector(selectors[i]) || document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function findAddToCart(root) {
    var scope =
      (root && root.closest("product-info, .product, main, product-details")) ||
      document;
    var selectors = [
      'form[action*="/cart/add"] button[type="submit"]',
      "add-to-cart-component button",
      'button[name="add"]',
      ".product-form__submit",
      ".add-to-cart-button",
      'button[type="submit"].button',
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = scope.querySelector(selectors[i]);
      if (el) return el;
    }
    return document.querySelector(
      'form[action*="/cart/add"] button[type="submit"], button[name="add"]'
    );
  }

  function findVariantInput(root) {
    var scope =
      (root && root.closest("product-info, .product, main")) || document;
    return (
      scope.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      scope.querySelector('input[name="id"]')
    );
  }

  function bindCard(card) {
    if (card.getAttribute("data-op-bound") === "1") return;
    card.setAttribute("data-op-bound", "1");

    var boxM2 = parseFloat(card.getAttribute("data-box-m2"));
    // 30 Sep 2026 price-leak close: map-hide PDPs no longer ship data-price-per-box in the HTML; it is
    // filled client-side (assets/onlyplanks-map-price.js) after unlock. Read it lazily, never require it.
    function getPriceBox() {
      var v = parseFloat(card.getAttribute("data-price-per-box"));
      return isFinite(v) && v > 0 ? v : 0;
    }
    var input = card.querySelector(".op-box-m2-input");
    var nEl = card.querySelector(".op-box-n");
    var coverEl = card.querySelector(".op-box-cover");
    var totalEl = card.querySelector(".op-box-total");
    var applyBtn = card.querySelector(".op-box-apply");

    if (!boxM2 || !input) return;

    var lastBoxes = null;

    function compute() {
      var raw = parseFloat(String(input.value).replace(",", "."));
      if (!isFinite(raw) || raw <= 0) {
        if (nEl) nEl.textContent = "—";
        if (coverEl) coverEl.textContent = "—";
        if (totalEl) totalEl.textContent = "—";
        lastBoxes = null;
        if (applyBtn && card.classList.contains("op-box-sell--buy")) {
          applyBtn.textContent = "Use this quantity";
          applyBtn.disabled = true;
        }
        return null;
      }
      var boxes = Math.ceil(raw / boxM2);
      if (boxes < 1) boxes = 1;
      var cover = boxes * boxM2;
      var priceBox = getPriceBox();
      var total = priceBox ? boxes * priceBox : null;
      lastBoxes = boxes;
      if (nEl) nEl.textContent = String(boxes);
      if (coverEl) {
        var c = Math.round(cover * 10000) / 10000;
        coverEl.textContent = String(c);
      }
      if (totalEl) totalEl.textContent = total != null ? money(total) : "—";
      if (applyBtn && card.classList.contains("op-box-sell--buy")) {
        applyBtn.disabled = false;
        applyBtn.textContent = boxes === 1 ? "Use 1 box" : "Use " + boxes + " boxes";
      }
      if (!reduce) {
        card.classList.add("op-box-updated");
        window.setTimeout(function () {
          card.classList.remove("op-box-updated");
        }, 280);
      }
      return boxes;
    }

    function setQty(boxes) {
      if (!boxes) return;
      var qty = findQtyInput(card);
      if (!qty) return;
      qty.value = String(boxes);
      try {
        qty.dispatchEvent(new Event("input", { bubbles: true }));
        qty.dispatchEvent(new Event("change", { bubbles: true }));
      } catch (e) {}
    }

    function useQuantity(boxes) {
      if (!boxes) return;
      setQty(boxes);
    }

    input.addEventListener("input", compute);
    input.addEventListener("change", compute);
    if (applyBtn) {
      applyBtn.disabled = true;
      applyBtn.addEventListener("click", function (ev) {
        ev.preventDefault();
        var boxes = compute();
        if (!boxes) return;
        if (card.classList.contains("op-box-sell--buy")) {
          useQuantity(boxes);
        } else {
          setQty(boxes);
        }
      });
    }
  }

  function hideDescriptionDupes() {
    // Prefer buy-column calc; hide description copies so shoppers aren't confused
    var buy = document.querySelector(".op-box-sell--buy");
    if (!buy) return;
    var all = document.querySelectorAll(".op-box-sell");
    for (var i = 0; i < all.length; i++) {
      if (!all[i].classList.contains("op-box-sell--buy")) {
        all[i].style.display = "none";
      }
    }
  }

  function scan() {
    hideDescriptionDupes();
    var cards = document.querySelectorAll(".op-box-sell");
    for (var i = 0; i < cards.length; i++) bindCard(cards[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }
  document.addEventListener("shopify:section:load", scan);
  // Variant changes may swap price — refresh data-price-per-box from dual price block if present
  document.addEventListener("variant:change", function () {
    var dual = document.querySelector(".op-price-dual[data-op-price-per-box]");
    var buy = document.querySelector(".op-box-sell--buy");
    if (dual && buy) {
      buy.setAttribute("data-price-per-box", dual.getAttribute("data-op-price-per-box"));
      var input = buy.querySelector(".op-box-m2-input");
      if (input) input.dispatchEvent(new Event("input", { bubbles: true }));
    }
  });
})();
